"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClassOpcodeTemplates = getClassOpcodeTemplates;
function getClassOpcodeTemplates() {
    return `
                        // Class Operations (Getters/Setters)
                        case opMap[145]: { // DEFINE_GETTER
                            // Define a getter on an object or class prototype
                            // Stack before: [object, getterFunction]
                            // Stack after: [object] (with getter defined)
                            // arg: property name index in constant pool
                            let getterFunc = stack.pop();
                            let getObj = stack[stack.length - 1]; // Peek at object (don't pop)
                            let getPropName = constants[arg];
                            // If getObj is a constructor (has prototype), define on prototype
                            // Otherwise define on the object itself
                            let getTarget = (typeof getObj === 'function' && getObj.prototype) ? getObj.prototype : getObj;
                            Object.defineProperty(getTarget, getPropName, {
                                get: getterFunc,
                                enumerable: getTarget === getObj, // enumerable for objects, non-enumerable for prototypes
                                configurable: true
                            });
                            pc++;
                            break;
                        }

                        case opMap[146]: { // DEFINE_SETTER
                            // Define a setter on an object or class prototype
                            // Stack before: [object, setterFunction]
                            // Stack after: [object] (with setter defined)
                            // arg: property name index in constant pool
                            let setterFunc = stack.pop();
                            let setObj = stack[stack.length - 1]; // Peek at object (don't pop)
                            let setPropName = constants[arg];
                            // If setObj is a constructor (has prototype), define on prototype
                            // Otherwise define on the object itself
                            let setTarget = (typeof setObj === 'function' && setObj.prototype) ? setObj.prototype : setObj;
                            Object.defineProperty(setTarget, setPropName, {
                                set: setterFunc,
                                enumerable: setTarget === setObj, // enumerable for objects, non-enumerable for prototypes
                                configurable: true
                            });
                            pc++;
                            break;
                        }

                        case opMap[140]: { // NEW_CLASS
                            // Create a class constructor function
                            // Stack before: [constructorFunc, className (or null)]
                            // Stack after: [classConstructor]
                            // arg: isDerived flag (0 = base class, 1 = derived class)
                            let className = stack.pop();
                            let ctorFunc = stack.pop();
                            let isDerived = arg;

                            // Create constructor function that calls the bytecode
                            // IMPORTANT: Use IIFE to create proper closure scope
                            // Without this, all ClassConstructors share the same className/ctorFunc variables!
                            let ClassConstructor = (function(capturedClassName, capturedCtorFunc, capturedIsDerived) {
                                // Create the constructor function
                                let ConstructorFunc;
                                if (capturedIsDerived) {
                                    // DERIVED CLASS: Cannot access 'this' before super() is called
                                    // The 'this' is in TDZ (Temporal Dead Zone) until super() initializes it
                                    ConstructorFunc = function() {
                                        if (capturedCtorFunc) {
                                            // Inject __$$constructor$$__ as a special variable that the bytecode can access
                                            // This allows super() to load the parent class from ConstructorFunc.__$$super$$__
                                            // without needing to access 'this.constructor' (which would throw TDZ error)
                                            {vmGlobalsName}['__$$constructor$$__'] = ConstructorFunc;
                                            // Store new.target so VM executor can access it
                                            // If already set by super() call, don't overwrite it
                                            let hadNewTarget = '__$$newTarget$$__' in {vmGlobalsName};
                                            if (!hadNewTarget) {
                                                {vmGlobalsName}['__$$newTarget$$__'] = new.target;
                                            }
                                            try {
                                                // DON'T use .apply(this, ...) because 'this' is uninitialized!
                                                // Instead, call with proper binding where 'this' will be accessible
                                                // after super() runs inside the bytecode
                                                // Convert arguments to array
                                                let ctorArgs = [];
                                                for (let _loopIdx = 0; _loopIdx < arguments.length; _loopIdx++) {
                                                    ctorArgs.push(arguments[_loopIdx]);
                                                }
                                                return capturedCtorFunc.apply(this, ctorArgs);
                                            } finally {
                                                // Clean up after constructor runs
                                                delete {vmGlobalsName}['__$$constructor$$__'];
                                                if (!hadNewTarget) {
                                                    delete {vmGlobalsName}['__$$newTarget$$__'];
                                                }
                                            }
                                        }
                                    };
                                } else {
                                    // BASE CLASS: 'this' is created by 'new' operator
                                    ConstructorFunc = function() {
                                        // Call the constructor bytecode with proper 'this' binding
                                        // If no constructor bytecode, return undefined and let 'new' operator return 'this'
                                        if (capturedCtorFunc) {
                                            // Store new.target so VM executor can access it
                                            // If already set by super() call, don't overwrite it
                                            let hadNewTarget = '__$$newTarget$$__' in {vmGlobalsName};
                                            if (!hadNewTarget) {
                                                {vmGlobalsName}['__$$newTarget$$__'] = new.target;
                                            }
                                            try {
                                                // Convert arguments to array
                                                let ctorArgs = [];
                                                for (let _loopIdx = 0; _loopIdx < arguments.length; _loopIdx++) {
                                                    ctorArgs.push(arguments[_loopIdx]);
                                                }
                                                return capturedCtorFunc.apply(this, ctorArgs);
                                            } finally {
                                                if (!hadNewTarget) {
                                                    delete {vmGlobalsName}['__$$newTarget$$__'];
                                                }
                                            }
                                        }
                                        // No explicit return needed - constructor functions automatically return 'this' when called with 'new'
                                    };
                                }
                                return ConstructorFunc;
                            })(className, ctorFunc, isDerived);
                            // Set constructor name if provided
                            if (className) {
                                Object.defineProperty(ClassConstructor, 'name', {
                                    value: className,
                                    configurable: true
                                });
                            }
                            stack.push(ClassConstructor);

                            pc++;
                            break;
                        }

                        case opMap[141]: { // CLASS_EXTENDS
                            // Set up class inheritance
                            // Stack before: [childClass, parentClass]
                            // Stack after: [childClass] (with inheritance set up)
                            // arg: not used
                            let ParentClass = stack.pop();
                            let ChildClass = stack[stack.length - 1]; // Peek (don't pop)

                            // Set up prototype chain
                            Object.setPrototypeOf(ChildClass.prototype, ParentClass.prototype);
                            Object.setPrototypeOf(ChildClass, ParentClass);

                            // Store parent class on the child class for super() to access
                            // This prevents the multi-level inheritance bug where all classes
                            // share the same global __$$super$$__ variable
                            ChildClass.__$$super$$__ = ParentClass;

                            pc++;
                            break;
                        }

                        case opMap[142]: { // GET_SUPER_PROP
                            // Access super.property
                            // Stack before: [this, propertyName]
                            // Stack after: [value]
                            // arg: not used (property name is on stack for dynamic access)
                            let superPropName = stack.pop();
                            let superThis = stack.pop();

                            // Get the prototype of the current class's prototype
                            let proto = Object.getPrototypeOf(Object.getPrototypeOf(superThis));

                            // Check if it's a getter/setter
                            let descriptor = Object.getOwnPropertyDescriptor(proto, superPropName);
                            let superValue;

                            if (descriptor && descriptor.get) {
                                // It's a getter - call it with superThis as the context
                                superValue = descriptor.get.call(superThis);
                                stack.push(superValue);
                            } else {
                                // Regular property or method
                                superValue = proto[superPropName];
                                // If it's a method, bind it to 'this'
                                if (typeof superValue === 'function') {
                                    stack.push(superValue.bind(superThis));
                                } else {
                                    stack.push(superValue);
                                }
                            }
                            pc++;
                            break;
                        }

                        case opMap[143]: { // SET_SUPER_PROP
                            // Set super.property = value
                            // Stack before: [this, propertyName, value]
                            // Stack after: [value]
                            // arg: not used
                            let superSetValue = stack.pop();
                            let superSetPropName = stack.pop();
                            let superSetThis = stack.pop();
                            // Get the prototype of the current class's prototype
                            let superSetProto = Object.getPrototypeOf(Object.getPrototypeOf(superSetThis));
                            superSetProto[superSetPropName] = superSetValue;
                            stack.push(superSetValue);
                            pc++;
                            break;
                        }

                        case opMap[144]: { // DEFINE_METHOD
                            // Define a method on class prototype
                            // Stack before: [class, methodFunction]
                            // Stack after: [class] (with method defined on prototype)
                            // arg: method name index in constant pool
                            let methodFunc = stack.pop();
                            let methodClass = stack[stack.length - 1]; // Peek (don't pop)
                            let methodName = constants[arg];


                            Object.defineProperty(methodClass.prototype, methodName, {
                                value: methodFunc,
                                writable: true,
                                enumerable: false,
                                configurable: true
                            });
                            pc++;
                            break;
                        }

                        case opMap[147]: { // DEFINE_STATIC_METHOD
                            // Define a static method on class constructor
                            // Stack before: [class, methodFunction]
                            // Stack after: [class] (with static method defined on class itself)
                            // arg: method name index in constant pool
                            let staticMethodFunc = stack.pop();
                            let staticMethodClass = stack[stack.length - 1]; // Peek (don't pop)
                            let staticMethodName = constants[arg];

                            Object.defineProperty(staticMethodClass, staticMethodName, {
                                value: staticMethodFunc,
                                writable: true,
                                enumerable: false,
                                configurable: true
                            });
                            pc++;
                            break;
                        }

                        case opMap[148]: { // DEFINE_STATIC_GETTER
                            // Define a static getter on class constructor
                            // Stack before: [class, getterFunction]
                            // Stack after: [class] (with static getter defined on class itself)
                            // arg: property name index in constant pool
                            let staticGetterFunc = stack.pop();
                            let staticGetterClass = stack[stack.length - 1]; // Peek (don't pop)
                            let staticGetterName = constants[arg];

                            Object.defineProperty(staticGetterClass, staticGetterName, {
                                get: staticGetterFunc,
                                enumerable: false,
                                configurable: true
                            });
                            pc++;
                            break;
                        }

                        case opMap[149]: { // DEFINE_STATIC_SETTER
                            // Define a static setter on class constructor
                            // Stack before: [class, setterFunction]
                            // Stack after: [class] (with static setter defined on class itself)
                            // arg: property name index in constant pool
                            let staticSetterFunc = stack.pop();
                            let staticSetterClass = stack[stack.length - 1]; // Peek (don't pop)
                            let staticSetterName = constants[arg];

                            Object.defineProperty(staticSetterClass, staticSetterName, {
                                set: staticSetterFunc,
                                enumerable: false,
                                configurable: true
                            });
                            pc++;
                            break;
                        }

                        case opMap[170]: { // DEFINE_METHOD_COMPUTED
                            // Define method with computed property name (name on stack)
                            // Stack before: [class, methodName, methodFunction]
                            // Stack after: [class]
                            let computedMethodFunc = stack.pop();
                            let computedMethodName = stack.pop();
                            let computedMethodClass = stack[stack.length - 1]; // Peek

                            Object.defineProperty(computedMethodClass.prototype, computedMethodName, {
                                value: computedMethodFunc,
                                writable: true,
                                enumerable: false,
                                configurable: true
                            });
                            pc++;
                            break;
                        }

                        case opMap[171]: { // DEFINE_STATIC_METHOD_COMPUTED
                            // Define static method with computed property name
                            // Stack before: [class, methodName, methodFunction]
                            // Stack after: [class]
                            let computedStaticMethodFunc = stack.pop();
                            let computedStaticMethodName = stack.pop();
                            let computedStaticMethodClass = stack[stack.length - 1]; // Peek

                            Object.defineProperty(computedStaticMethodClass, computedStaticMethodName, {
                                value: computedStaticMethodFunc,
                                writable: true,
                                enumerable: false,
                                configurable: true
                            });
                            pc++;
                            break;
                        }

                        case opMap[172]: { // DEFINE_GETTER_COMPUTED
                            // Define getter with computed property name
                            // Stack before: [object/class, propName, getterFunction]
                            // Stack after: [object/class]
                            let computedGetterFunc = stack.pop();
                            let computedGetterName = stack.pop();
                            let computedGetterObj = stack[stack.length - 1]; // Peek
                            // If target is a constructor (has prototype), define on prototype
                            // Otherwise define on the object itself (for object literals)
                            let computedGetterTarget = (typeof computedGetterObj === 'function' && computedGetterObj.prototype) ? computedGetterObj.prototype : computedGetterObj;

                            Object.defineProperty(computedGetterTarget, computedGetterName, {
                                get: computedGetterFunc,
                                enumerable: computedGetterTarget === computedGetterObj, // enumerable for objects, non-enumerable for prototypes
                                configurable: true
                            });
                            pc++;
                            break;
                        }

                        case opMap[173]: { // DEFINE_SETTER_COMPUTED
                            // Define setter with computed property name
                            // Stack before: [object/class, propName, setterFunction]
                            // Stack after: [object/class]
                            let computedSetterFunc = stack.pop();
                            let computedSetterName = stack.pop();
                            let computedSetterObj = stack[stack.length - 1]; // Peek
                            // If target is a constructor (has prototype), define on prototype
                            // Otherwise define on the object itself (for object literals)
                            let computedSetterTarget = (typeof computedSetterObj === 'function' && computedSetterObj.prototype) ? computedSetterObj.prototype : computedSetterObj;

                            Object.defineProperty(computedSetterTarget, computedSetterName, {
                                set: computedSetterFunc,
                                enumerable: computedSetterTarget === computedSetterObj, // enumerable for objects, non-enumerable for prototypes
                                configurable: true
                            });
                            pc++;
                            break;
                        }

                        case opMap[174]: { // DEFINE_STATIC_GETTER_COMPUTED
                            // Define static getter with computed property name
                            // Stack before: [class, propName, getterFunction]
                            // Stack after: [class]
                            let computedStaticGetterFunc = stack.pop();
                            let computedStaticGetterName = stack.pop();
                            let computedStaticGetterClass = stack[stack.length - 1]; // Peek

                            Object.defineProperty(computedStaticGetterClass, computedStaticGetterName, {
                                get: computedStaticGetterFunc,
                                enumerable: false,
                                configurable: true
                            });
                            pc++;
                            break;
                        }

                        case opMap[175]: { // DEFINE_STATIC_SETTER_COMPUTED
                            // Define static setter with computed property name
                            // Stack before: [class, propName, setterFunction]
                            // Stack after: [class]
                            let computedStaticSetterFunc = stack.pop();
                            let computedStaticSetterName = stack.pop();
                            let computedStaticSetterClass = stack[stack.length - 1]; // Peek

                            Object.defineProperty(computedStaticSetterClass, computedStaticSetterName, {
                                set: computedStaticSetterFunc,
                                enumerable: false,
                                configurable: true
                            });
                            pc++;
                            break;
                        }
    `;
}
